module.exports = __webpack_public_path__ + "media/images/links/farmacias-f8da02ec77f974f9c747569ad0e31bf0.jpg";